import { CommonModule } from '@angular/common';
import { LoadingAnimationModule } from '@caslink/common-client/ng-app/loadingAnimation/LoadingAnimationModule';
import { MatButtonModule } from '@angular/material/button';
import { MenuModule } from '@caslink/common-client/ng-app/menu/menu.module';
import { MonitoringToolbarComponent } from './monitoring-toolbar.component';
import { NavToolbarModule } from '@caslink/common-client/ng-app/nav-toolbar/nav-toolbar.module';
import { NgModule } from '@angular/core';
import { SubToolbarModule } from '@caslink/common-client/ng-app/sub-toolbar/sub-toolbar.module';
import { TogglerModule } from '@caslink/common-client/ng-app/toggler/toggler.module';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
    imports: [
        CommonModule,
        LoadingAnimationModule,
        MatButtonModule,
        MatIconModule,
        MenuModule,
        NavToolbarModule,
        SubToolbarModule,
        TogglerModule,
    ],
    declarations: [
        MonitoringToolbarComponent,
    ],
    exports: [
        MonitoringToolbarComponent,
    ],
})
export class MonitoringToolbarModule {}
